import dayjs from "dayjs";
import { isAfterOrSame, isBeforeOrSame } from "./date";

export const getElementStatus = (data, currentDate) => {
  let planHideIds = [];
  let actualHideIds = [];
  let delayedNotStartIds = [];
  let planProgressIds = [];
  let actualProgressIds = [];
  let delayedInProgressIds = [];
  let planCompleteIds = [];
  let actualCompleteIds = [];
  let showFilterIds = [];

  if (Array.isArray(data)) {
    data
      .filter((d) => d.planStartDate)
      .forEach((item) => {
        const actualStartDate = item.actualStartDate ? dayjs(item.actualStartDate) : null;
        const actualEndDate = item.actualEndDate ? dayjs(item.actualEndDate) : null;
        const planStartDate = item.planStartDate ? dayjs(item.planStartDate) : null;
        const planEndDate = item.planEndDate ? dayjs(item.planEndDate) : null;

        //如果元素关联的任务 ID 的工作类型为“建造”（Construct）或“临时”（Temporary）,隐藏该元素
        // if (item.workType === "Construct" || item.workType === "Temporary") {
        //     if (!notStartedIds.includes(item.bimElementId)) {
        //         notStartedIds.push(item.bimElementId);
        //     }
        // }
        if (!showFilterIds.includes(item.bimElementId)) {
          showFilterIds.push(item.bimElementId);
        }

        if (currentDate) {
          // check if it is not start (Not Start Plan)
          if (planStartDate && planStartDate.isAfter(currentDate, "day")) {
            // hide element if the corresponding Task ID do not work type as “Demolish”
            if (item.workType !== "Demolish") {
              if (!planHideIds.includes(item.bimElementId)) {
                planHideIds.push(item.bimElementId);
              }
            }
          }
          // check if it is not start (Not Start Actual)
          if (!actualStartDate || actualStartDate.isAfter(currentDate, "day")) {
            // check if it is not start and delay (Not Start (Delay) Actual)
            if (planStartDate && isBeforeOrSame(planStartDate, currentDate)) {
              if (!delayedNotStartIds.includes(item.bimElementId)) {
                delayedNotStartIds.push(item.bimElementId);
              }
            } else {
              // hide element if the corresponding Task ID do not work type as “Demolish”
              if (item.workType !== "Demolish") {
                if (!actualHideIds.includes(item.bimElementId)) {
                  actualHideIds.push(item.bimElementId);
                }
              }
            }
          }

          // 检查是否为“进行中”（WIP Plan）
          if (planStartDate && isBeforeOrSame(planStartDate, currentDate)) {
            if (!planEndDate || isAfterOrSame(planEndDate, currentDate)) {
              // 条件：当前选择的日期已超过计划的开始日期，但尚未超過计划的结束日期。
              if (!planProgressIds.includes(item.bimElementId)) {
                planProgressIds.push(item.bimElementId);
              }
            }
          }

          // 检查是否为“进行中”（WIP Actual）
          if (actualStartDate && isBeforeOrSame(actualStartDate, currentDate)) {
            if (!actualEndDate || isAfterOrSame(actualEndDate, currentDate)) {
              if (!planEndDate || isAfterOrSame(planEndDate, currentDate)) {
                // 条件：当前选择的日期已超过实际的开始日期，但尚未达到实际的结束日期，
                // 或者元素没有实际的结束日期，并且当前选择的日期尚未超过计划的结束日期。
                if (!actualProgressIds.includes(item.bimElementId)) {
                  actualProgressIds.push(item.bimElementId);
                }
              }
              // 检查是否为“进行中且延迟”（WIP and Delayed）
              else if (planEndDate && planEndDate.isBefore(currentDate, "day")) {
                // 条件：当前选择的日期已超过实际的开始日期，但尚未达到实际的结束日期，
                // 或者元素没有实际的结束日期，并且当前选择的日期已超过计划的结束日期。
                if (!delayedInProgressIds.includes(item.bimElementId)) {
                  delayedInProgressIds.push(item.bimElementId);
                }
              }
            }
          }

          // 检查是否为“已完成”（Complete Plan）
          if (planStartDate && planEndDate) {
            if (currentDate.isAfter(planEndDate, "day") || currentDate.isSame(planEndDate, "day")) {
              // 条件：当前选择的日期已超过计划的开始日期和结束日期。
              if (!planCompleteIds.includes(item.bimElementId)) {
                planCompleteIds.push(item.bimElementId);
              }
              // hide element if work type is "Demolish" or "Temporary"
              if (item.workType === "Demolish" || item.workType === "Temporary") {
                if (!planHideIds.includes(item.bimElementId)) {
                  planHideIds.push(item.bimElementId);
                }
              }
            }
          }

          // 检查是否为“已完成”（Complete Actual）
          if (actualStartDate && actualEndDate) {
            if (currentDate.isAfter(actualEndDate, "day") || currentDate.isSame(actualEndDate, "day")) {
              // 条件：当前选择的日期已超过计划的开始日期和结束日期。
              if (!actualCompleteIds.includes(item.bimElementId)) {
                actualCompleteIds.push(item.bimElementId);
              }
              // hide element if work type is "Demolish" or "Temporary"
              if (item.workType === "Demolish" || item.workType === "Temporary") {
                if (!actualHideIds.includes(item.bimElementId)) {
                  actualHideIds.push(item.bimElementId);
                }
              }
            }
          }
        }
      });
  }
  return {
    planHide: planHideIds,
    actualHide: actualHideIds,
    delayedNotStart: delayedNotStartIds,
    planProgress: planProgressIds,
    actualProgress: actualProgressIds,
    delayed: delayedInProgressIds,
    planComplete: planCompleteIds,
    actualComplete: actualCompleteIds,
    showFilter: showFilterIds,
  };
};

export const getStatusString = (ps, pe, as, ae, cd) => {
  const planStartDate = ps ? dayjs(ps) : null;
  const planEndDate = pe ? dayjs(pe) : null;
  const actualStartDate = as ? dayjs(as) : null;
  const actualEndDate = ae ? dayjs(ae) : null;
  const currentDate = cd ? dayjs(cd) : null;
  if (currentDate) {
    if (actualStartDate && actualEndDate) {
      return "Complete";
    }
    if (actualStartDate && isBeforeOrSame(currentDate, planEndDate)) {
      return "WIP";
    }
    if (actualStartDate && currentDate.isAfter(planEndDate, "day")) {
      return "WIP(Delay)";
    }
    if (!actualStartDate && planStartDate?.isAfter(currentDate, "day")) {
      return "Not Start";
    }
    if (!planStartDate) {
      return null;
    }
    return "Not Start(Delay)";
  }
  return null;
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "Complete":
      return <img src="assets/icons/greencircle.svg" alt="Green Circle" style={{ verticalAlign: "middle" }} />;
    case "WIP":
      return <img src="assets/icons/yellowcircle.svg" alt="Yellow Circle" style={{ verticalAlign: "middle" }} />;
    case "WIP(Delay)":
      return <img src="assets/icons/orangecircle.svg" alt="Orange Circle" style={{ verticalAlign: "middle" }} />;
    case "Not Start":
      return <img src="assets/icons/whitecircle.svg" alt="White Circle" style={{ verticalAlign: "middle" }} />;
    case "Not Start(Delay)":
      return <img src="assets/icons/redbordercircle.svg" alt="Redborder Circle" style={{ verticalAlign: "middle" }} />;
    default:
      return null;
  }
};

export const calculateGanttDateRange = (data, projectDetails) => {
  const defaultMinDate = dayjs("2999-12-31");
  const defaultMaxDate = dayjs("1000-01-01");

  let minDate = data.reduce((prevMin, task) => {
    const planStart = task.planStart ? dayjs(task.planStart) : null;
    const actualStart = task.actualStart ? dayjs(task.actualStart) : null;
    let start = planStart;

    if (actualStart && planStart && actualStart.isBefore(planStart)) {
      start = actualStart;
    } else if (actualStart && !planStart) {
      start = actualStart;
    }

    if (start && start.isValid() && start.isBefore(prevMin)) {
      return start;
    }

    return prevMin;
  }, defaultMinDate);

  let maxDate = data.reduce((prevMax, task) => {
    const planEnd = task.planEnd ? dayjs(task.planEnd) : null;
    const actualEnd = task.actualEnd ? dayjs(task.actualEnd) : null;
    let end = planEnd;

    if (actualEnd && planEnd && actualEnd.isAfter(planEnd)) {
      end = actualEnd;
    } else if (actualEnd && !planEnd) {
      end = actualEnd;
    }

    if (end && end.isValid() && end.isAfter(prevMax)) {
      return end;
    }

    return prevMax;
  }, defaultMaxDate);

  if (minDate.isSame(defaultMinDate, 'day')) {
    const projectStartDate = projectDetails?.startDate ? dayjs(projectDetails.startDate) : null;
    if (projectStartDate && projectStartDate.isValid()) {
      minDate = projectStartDate;
    } else {
      minDate = dayjs();
    }
  }

  if (maxDate.isSame(defaultMaxDate, 'day')) {
    const projectEndDate = projectDetails?.endDate ? dayjs(projectDetails.endDate) : null;
    if (projectEndDate && projectEndDate.isValid()) {
      maxDate = projectEndDate;
    } else {
      maxDate = minDate.add(180, 'days');
    }
  }

  return {
    startDate: minDate,
    endDate: maxDate,
  };
};